/* eslint-disable @typescript-eslint/no-var-requires */
import "core-js/stable";
import "regenerator-runtime/runtime";
import { createApp } from "vue";
import App from "./App.vue";
import VueWechatTitle from "vue-wechat-title";
import "./utils/rem";
import "./utils/af";
import './assets/css/font.css'
// vant样式由unplugin-vue-components自动导入，无需手动引入
import "vant/lib/index.css";
// 手动导入一些常用的vant组件确保正常工作
import { Button, Field, Dialog, Toast, Icon, CellGroup, DropdownMenu, DropdownItem, Uploader, RadioGroup, Radio, Checkbox, CheckboxGroup } from 'vant';

import VConsole from "vconsole";
if (process.env.NODE_ENV !== 'production') {
  new VConsole();
}

let router;
if (process.env.VUE_APP_NAME === 'ReelFree') {
  router = require(/* webpackChunkName: "reel-free-router" */ './router/index-reel-free').default
} else if (process.env.VUE_APP_NAME === 'SparkShort') {
  router = require(/* webpackChunkName: "spark-short-router" */ './router/index-spark-short').default
} else {
  router = require(/* webpackChunkName: "default-router" */ './router/index').default
}

const app = createApp(App);
// 注册常用的vant组件
app.use(Button);
app.use(Field);
app.use(Dialog);
app.use(Toast);
app.use(Icon);
app.use(CellGroup);
app.use(DropdownMenu);
app.use(DropdownItem);
app.use(Uploader);
app.use(RadioGroup);
app.use(Radio);
app.use(Checkbox);
app.use(CheckboxGroup);
console.info('页面链接：', window.location.href)
app
  .use(router)
  .use(VueWechatTitle)
  .mount("#app");
